import React from "react";
import Header from "@/components/landing/Header";
import WhoAmISection from "@/components/landing/WhoAmISection";
import RelatedPages from "@/components/landing/RelatedPages";
import { ABOUT_PAGES } from "@/data/navigation";
import NextPageCTA from "@/components/landing/NextPageCTA";
import PageFooter from "@/components/landing/PageFooter";

export default function About() {
  return (
    <main className="bg-warm text-graphite min-h-screen">
      <Header />
      <div className="pt-24 md:pt-28" />
      <WhoAmISection />
      <RelatedPages
        pages={ABOUT_PAGES.filter((p) => p.to !== "/ki-vagyok-en")}
        testId="related-pages-about"
      />
      <NextPageCTA testId="next-page-cta-about" />
      <PageFooter />
    </main>
  );
}
